import React from "react";
import { twMerge } from "tailwind-merge";

const VARIANTS = {
  /** Opaque canvas bar (create event, profile save). */
  solid:
    "fixed inset-x-0 bottom-0 z-40 border-t border-black/[0.08] bg-canvas px-4 pt-3 pb-[max(12px,env(safe-area-inset-bottom))]",
  /** Translucent demo-style bar. */
  blur:
    "fixed bottom-0 inset-x-0 z-40 p-4 pb-[max(1rem,env(safe-area-inset-bottom))] bg-canvas/95 border-t border-black/[0.06] backdrop-blur-sm",
};

/**
 * Fixed mobile thumb-zone action bar.
 * Outer chrome only — put a flex row (or hint + row) as children inside max-w-page.
 */
export default function StickyBar({
  children,
  className = "",
  variant = "solid",
  testId,
  hideOnDesktop = false,
  innerClassName = "",
  ...rest
}) {
  return (
    <div
      className={twMerge(
        VARIANTS[variant] || VARIANTS.solid,
        hideOnDesktop ? "sm:hidden" : null,
        className
      )}
      data-testid={testId}
      {...rest}
    >
      <div className={twMerge("max-w-page mx-auto", innerClassName)}>{children}</div>
    </div>
  );
}
